module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_500_750.fff06a5f.png";